import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeaderboardPublicService {

  constructor(private http: HttpClient) { }

  getPublicGroup(token: string): Observable<any> {
    return this.http.get('/api/LeaderboardPublicApi/Get/' + token);
  }
}
